var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowNarrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.16553 11.7656C6.0155 11.9156 5.81206 11.9998 5.59993 11.9998C5.3878 11.9998 5.18435 11.9156 5.03433 11.7656L1.83433 8.5656C1.68435 8.41557 1.6001 8.21213 1.6001 8C1.6001 7.78786 1.68435 7.58442 1.83433 7.4344L5.03433 4.2344C5.18521 4.08867 5.38729 4.00803 5.59705 4.00986C5.80681 4.01168 6.00745 4.09581 6.15578 4.24414C6.30411 4.39247 6.38824 4.59312 6.39007 4.80288C6.39189 5.01263 6.31125 5.21471 6.16553 5.3656L4.33113 7.2H13.5999C13.8121 7.2 14.0156 7.28428 14.1656 7.43431C14.3156 7.58434 14.3999 7.78782 14.3999 8C14.3999 8.21217 14.3156 8.41565 14.1656 8.56568C14.0156 8.71571 13.8121 8.8 13.5999 8.8H4.33113L6.16553 10.6344C6.3155 10.7844 6.39976 10.9879 6.39976 11.2C6.39976 11.4121 6.3155 11.6156 6.16553 11.7656Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNarrowLeft);
export default __webpack_public_path__ + "static/media/ArrowNarrowLeft.28ec47353c44b27b7de38793f7e6c154.svg";
export { ForwardRef as ReactComponent };